export default __webpack_public_path__ + "static/media/backward.2a320896.svg";